import styled from 'styled-components'

export const IconWrapper = styled.div<{ isFavorite: boolean }>`
  cursor: pointer;
  width: 24px;
  color: ${({ isFavorite }) =>
    isFavorite ? 'var(--tds-orange-600)' : 'var(--tds-grey-600)'};

  &:hover {
    color: ${({ isFavorite }) =>
      isFavorite ? 'var(--tds-grey-500)' : 'var(--tds-orange-500)'};
  }
`
